<template>
    <div>
  
      <p>
<h2> 创建 订阅(包含免费试用和付费)与设备的对应关系,创建完成之后,显示创建结果  </h2>
      </p>
    
      <h3> 创建关系前 id 到 {{r.base_id}}  </h3>
      <h3> 更新记录  {{r.count}}  条   </h3>
      <h3> 当前最新id到   {{r.last_id}}  </h3>
  
    </div>
  </template>
  <script>



export default {
    data() {
      return  {   r:{
      }}
      },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/sync_device").then( (response)=>  {
this.r = response.data

    console.log(response.data)
  })
},

mounted:function(){
  console.log("/da/sync_device   挂载完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  